export default __webpack_public_path__ + "static/media/Peak-Noise-0.1.da6408ff.jpg";